export type OtParams = {
  redirectUri: string;
  stateRaw: string;
  stateParsed: Record<string, unknown>;
  incomingEntries: Record<string, string>;
  restaurantName: string;
  restaurantRegion: string;
};

export type OtParamsResult =
  | { ok: true; data: OtParams }
  | { ok: false; error: string };

export function readAndValidateOtParams(href: string): OtParamsResult {
  const url = new URL(href);
  const qp = url.searchParams;

  const redirectUri = qp.get('redirect_uri');
  if (!redirectUri) {
    return { ok: false, error: 'Login request is missing redirect_uri.' };
  }

  const stateRaw = qp.get('state');
  if (!stateRaw) {
    return { ok: false, error: 'Login request is missing state.' };
  }

  let stateParsed: Record<string, unknown>;
  try {
    stateParsed = JSON.parse(stateRaw);
  } catch {
    return { ok: false, error: 'Login request has an invalid state payload.' };
  }

  const restaurantName = qp.get('name') || '';

  const restaurantRegion = qp.get('region') || '';

  const incomingEntries = Object.fromEntries(qp.entries());

  return {
    ok: true,
    data: {
      redirectUri,
      stateRaw,
      stateParsed,
      incomingEntries,
      restaurantName,
      restaurantRegion,
    },
  };
}
